import * as React from 'react'

import { ApiClient } from '../../api'

export interface ApiContextValue {
  client?: ApiClient
}

export const canUseSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function'

// To make sure Api Client doesn't create more than one React context
// (which can lead to problems like having an Api Client instance added
// in one context, then attempting to retrieve it from another different
// context), a single Api context is created and tracked in global state.
const contextKey = canUseSymbol ? Symbol.for('__API_CONTEXT__') : '__API_CONTEXT__'

/**
 * The function returns a React context for the API context value.
 * @returns a React context object of type `React.Context<ApiContextValue>`.
 */
export function getApiContext(): React.Context<ApiContextValue> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let context = (React.createContext as any)[contextKey] as React.Context<ApiContextValue>
  if (!context) {
    Object.defineProperty(React.createContext, contextKey, {
      value: (context = React.createContext<ApiContextValue>({})),
      enumerable: false,
      writable: false,
      configurable: true,
    })
    context.displayName = 'ApiContext'
  }
  return context
}
